export default (img: HTMLImageElement): HTMLImageElement[] => {
  // canvas for default image orientation
  const horizontalCanvas = document.createElement('canvas');
  const horizontalCtx = horizontalCanvas.getContext('2d');

  // canvas for sideways image
  const verticalCanvas = document.createElement('canvas');
  const verticalCtx = verticalCanvas.getContext('2d');

  // Will generate all 4 orientations and store here
  const rotations: any[] = [];

  // set canvas dimensions
  horizontalCanvas.width = img.naturalWidth;
  horizontalCanvas.height = img.naturalHeight;
  verticalCanvas.width = img.naturalHeight;
  verticalCanvas.height = img.naturalWidth;

  // default version is incoming image
  rotations[0] = {
    src: img.src,
    width: img.naturalWidth,
    height: img.naturalHeight,
  };

  if (verticalCtx) {
    // handles 90º version
    // rotation will occur relative to canvas center
    verticalCtx.translate(img.naturalHeight / 2, img.naturalWidth / 2);
    // apply rotation
    verticalCtx.rotate(Math.PI / 2);
    // draw image. Accounts for translation thus the negative coords.
    // Rotation will be applied by context
    verticalCtx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
  }

  rotations[1] = {
    src: verticalCanvas.toDataURL('image/jpeg'), // store as data url
    width: img.naturalHeight, // store dimensions
    height: img.naturalWidth,
  };

  if (horizontalCtx) {
    // handles 180º version. Same as above only on default canvas and with 180º rotation
    horizontalCtx.translate(img.naturalWidth / 2, img.naturalHeight / 2);
    horizontalCtx.rotate(Math.PI);
    horizontalCtx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
  }

  rotations[2] = {
    src: horizontalCanvas.toDataURL('image/jpeg'),
    width: img.naturalWidth,
    height: img.naturalHeight,
  };

  if (verticalCtx) {
    // since some of the prep has been done for 90º, only needs to bump rotation by 180º and redraw
    verticalCtx.rotate(Math.PI);
    verticalCtx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
  }

  rotations[3] = {
    src: verticalCanvas.toDataURL('image/jpeg'),
    width: img.naturalHeight,
    height: img.naturalWidth,
  };

  return rotations; // returns all 4 preloaded versions
};
